import React, { forwardRef, memo, ForwardedRef } from 'react';
import styled from 'styled-components';
import Button from 'components/Button/Button';

const Container = styled.div`
  margin-bottom: var(--spacing-space8);
`;

interface Props {
  handleAddToBasket: () => void;
  disabled: boolean;
  updateBasket?: boolean;
}

const AddToBasketButton = forwardRef(
  ({ handleAddToBasket, disabled, updateBasket = false }: Props, ref: ForwardedRef<HTMLDivElement>) => (
    <Container ref={ref}>
      <Button
        id="primaryAddToBasket"
        onClick={() => handleAddToBasket()}
        data-testid="add_to_basket_button"
        disabled={disabled}
      >
        {updateBasket ? 'Update basket' : 'Add to basket'}
      </Button>
    </Container>
  ),
);

export default memo(AddToBasketButton);
